module.exports = __webpack_public_path__ + "img/DSC_0064.63542266.jpg";